import { Drawer } from "antd";
import { cloneElement, useState } from "react";

export const MobileMenu = ({ children, action }) => {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const renderAction = () => cloneElement(action, { onClick: showDrawer });
  const renderChildren = () => cloneElement(children, { onClick: onClose });

  return (
    <div>
      {/* ACTION BUTTON */}
      {renderAction()}

      {/* DRAWER */}
      <Drawer
        placement="bottom"
        title="Menu"
        closable={{ "aria-label": "Close Button" }}
        onClose={onClose}
        // width={200}
        height={300}
        open={open}
      >
        {/* CONTENT */}
        {renderChildren()}
      </Drawer>
    </div>
  );
};
